const ROOT_ROUTE = '/';
const DASHBOARD = 'dashboard';
const IMPORT_PAYROLL = 'upload-payroll-file/:period';
const REVIEW_IMPORT_PAYROLL = 'review-payroll-file';
const PAYROLL_PERIOD = 'payroll-period';
const SCHEDULES = 'schedules';
const EMPLOYEES = 'employees';
const EMPLOYER_REF = 'employer-reference';
const CONTRACT = 'contract';
const ERTN = 'ertn-batches';
const REPORTS = 'reports';
const USERS = 'users';
const NOTIFICATIONS = 'notifications';
const RECONCILIATION = 'reconciliation';
const RETRO_PAY = 'retro-pay';
const EMPLOYEE_PRINT = 'employee-print';
const USER_AGREEMENT = 'user-agreement';
const RATES = 'rates';
const IMPORT_RATES = 'upload-rates';
const MAINTENANCE_ROOT = 'maintenance';

const withRoot = (route: string) => `${ROOT_ROUTE}${route}`;
const ADMINISTRATION = 'administration';
const ROUTE_NAMES = {
  ROOT: ROOT_ROUTE,
  DASHBOARD: {
    DASHBOARD,
    IMPORT_PAYROLL: {
      ROOT: `${IMPORT_PAYROLL}`,
      FULL: `${withRoot(DASHBOARD)}${withRoot(IMPORT_PAYROLL)}`,
      REVIEW: `/dashboard/${REVIEW_IMPORT_PAYROLL}/:uploadId`,
    },
    PAYROLL_PERIOD: {
      FROM_NAV: PAYROLL_PERIOD,
      FROM_DASHBOARD: `/dashboard/${PAYROLL_PERIOD}/:year/:month`,
      PARAM_YEAR_ONLY: `/dashboard/${PAYROLL_PERIOD}/:year`,
      REST: `/dashboard/${PAYROLL_PERIOD}/*`,
    },
    EMPLOYEE_DETAILS: {
      ROOT: `/dashboard/employee/:employeeId`,
    },
  },
  SCHEDULES: {
    SCHEDULES,
  },
  EMPLOYEES: {
    EMPLOYEES,
  },
  REPORTS: {
    ROOT: REPORTS,
  },
  ERTN: {
    ROOT: ERTN,
  },
  ADMINISTRATION: {
    ADMINISTRATION,
    EMPLOYER_REF: `${ADMINISTRATION}/${EMPLOYER_REF}`,
    CONTRACT: `${ADMINISTRATION}/${CONTRACT}`,
    USERS: `${ADMINISTRATION}/${USERS}`,
    RATES: {
      ROOT: `${ADMINISTRATION}/${RATES}`,
      IMPORT: `${IMPORT_RATES}`,
    },
    NOTIFICATIONS: `${ADMINISTRATION}/${NOTIFICATIONS}`,
    RECONCILIATION: `${ADMINISTRATION}/${RECONCILIATION}`,
    RETRO_PAY: `${ADMINISTRATION}/${RETRO_PAY}`,
  },
  EMPLOYEE_PRINT: {
    ROOT: EMPLOYEE_PRINT,
  },
  USER_AGREEMENT: {
    ROOT: USER_AGREEMENT,
  },
  MAINTENANCE: {
    ROOT: MAINTENANCE_ROOT,
    MAIN: `/${MAINTENANCE_ROOT}`,
  },
  NOT_FOUND: `*`,
};

export { ROUTE_NAMES, withRoot };
